export class SapService {
    static async login() {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "username": "programadorit",
                "password": "Slackintosh12042024#",
            });

            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            const response = await fetch("https://consumos.talsa.com.co/api/talsa/v1/login", requestOptions);
            const result = await response.json();
            return result.token;
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        }
    }

    static async getData(url, token) {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("authorization", token);

            const raw = JSON.stringify({
                "url": url
            });

            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow',
            };

            const response = await fetch("https://consumos.talsa.com.co/api/talsa/v1/sap", requestOptions);
            const result = await response.json();
            return result;
        } catch (error) {
            console.error('SAP Data fetch error:', error);
            throw error;
        }
    }

    static async submitMaterials(query) {
        try {
            const response = await fetch("https://aplicaciones-854449656601.us-central1.run.app/bigquery/exec", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ query })
            });
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Submit Materials error:', error);
            throw error;
        }
    }

    static async notifyAppsScript(materials) {
        try {
            // Removed 'no-cors' to enable reading the response
            const response = await fetch("https://script.google.com/macros/s/AKfycbxanD2uHJPPPCcM-CWtV9cvdq1w23RZCJBFbO7WrnVXfgZZxGLFAzixV17FGrGRPE_pTw/exec", {
                method: "POST",
                headers: {
                    "Content-Type": "text/plain"
                },
                body: JSON.stringify(materials)
            });

            const text = await response.text();
            console.log("Apps Script Response:", text);

            // Attempt to extract code from format: "...}-21310114"
            const parts = text.split('}-');
            if (parts.length > 1) {
                const code = parts[parts.length - 1].trim();
                return { success: true, code: code };
            }

            return { success: true, code: null, raw: text };
        } catch (error) {
            console.error('Apps Script notification error:', error);
            return { success: false, error: error.message || error.toString() };
        }
    }

    static async loginApp(email, password) {
        try {
            const response = await fetch("https://consumos.talsa.com.co/api/talsa/materiales/loginApp", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });
            if (!response.ok) {
                throw new Error('Credenciales incorrectas');
            }
            return await response.json();
        } catch (error) {
            console.error('Error en loginApp:', error);
            throw error;
        }
    }

    static async loginGoogleApp(credential) {
        const response = await fetch("https://consumos.talsa.com.co/api/talsa/materiales/loginGoogleApp", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ credential })
        });
        if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data.error || 'Error al iniciar sesión con Google');
        }
        return await response.json();
    }

    static async getMaterialesPorFecha(fecha) {
        try {
            const response = await fetch(`https://consumos.talsa.com.co/api/talsa/materiales/materiales/${fecha}`);
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error al obtener materiales');
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error getting materials by date:', error);
            throw error;
        }
    }

    static async loginEmail() {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "username": "programadorit",
                "password": "Slackintosh12042024#"
            });

            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            const response = await fetch("https://consumos.talsa.com.co/api/talsa/pagina/login", requestOptions);
            const result = await response.json();
            return result.token;
        } catch (error) {
            console.error('Email Login error:', error);
            throw error;
        }
    }

    static async enviarCorreos(correoData) {
        try {
            // 1. Authenticate to get token
            const token = await this.loginEmail();

            // 2. Send email with token
            const response = await fetch("https://consumos.talsa.com.co/api/talsa/v1/enviarCorreos", {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                },
                body: JSON.stringify(correoData)
            });
            const result = await response.json();
            return result;
        } catch (error) {
            console.error('Error sending email:', error);
            throw error;
        }
    }

    static async getUsuarios() {
        const response = await fetch("https://consumos.talsa.com.co/api/talsa/materiales/usuarios");
        if (!response.ok) throw new Error('Error al obtener usuarios');
        return await response.json();
    }

    static async crearUsuario(data) {
        const response = await fetch("https://consumos.talsa.com.co/api/talsa/materiales/usuarios", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || 'Error al crear usuario');
        return result;
    }

    static async actualizarUsuario(email, data) {
        const encodedEmail = encodeURIComponent(email);
        const response = await fetch(`https://consumos.talsa.com.co/api/talsa/materiales/usuarios/${encodedEmail}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || 'Error al actualizar usuario');
        return result;
    }
}
